<template>
  <px-input-currency
    dense
    label="Valor total"
    class="required rounded-tag-small"
    @blur="onBlur"
    v-bind="$attrs"
    v-model="localValue"/>
</template>

<script>
export default {
  props: {
    value: Number,
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    onBlur(event) {
      this.$emit('blur', event);
    },
  },
};
</script>
